
    <div class="ngx-dropdown-container" tabindex="0">
        <button type="button" class="ngx-dropdown-button" [ngClass]="{'disabled':disabled}" [disabled]="disabled"
            (click)="toggleSelectDropdown()">
            <span>{{selectedDisplayText}} </span>
            <span class="nsdicon-angle-down"></span>
        </button>
        <div class="ngx-dropdown-list-container" *ngIf="toggleDropdown" [style.maxHeight]="config.height">
            <div class="search-container" *ngIf="config.search">
                <input [style.direction]="config.inputDirection" name="search-text" (input)="searchTextChanged()"
                    [(ngModel)]="searchText" autocomplete="off" />
                <label [ngClass]="{'active': searchText}">
                    <span class="nsdicon-search"></span> {{config.searchPlaceholder}}</label>
            </div>
            <ul class="selected-items">
                <li tabindex="-1" *ngFor="let selected of selectedItems;let i = index" (click)="deselectItem(selected,i)">
                    <span class="nsdicon-close">x</span>
                    <span> {{selected[config.displayKey] || selected}}</span>
                </li>
            </ul>
            <hr *ngIf="selectedItems.length > 0 && availableItems.length > 0" />
            <ul class="available-items">
                <li #availableOption
                    *ngFor="let item of availableItems| filterBy: searchText : config.searchOnKey | limitTo : config.limitTo;let i = index"
                    tabindex="-1" [ngClass]="{'active': focusedItemIndex == i}" (click)="selectItem(item,i)">
                    {{item[config.displayKey] || item}}</li>
                <li *ngIf="showNotFound">{{config.noResultsFound}}</li>
            </ul>
        </div>
    </div>
  